import type { BlogPost } from './types';

const items = import.meta.glob<BlogPost>('./blog/*.json', { eager: true, import: 'default' });
const bodies = import.meta.glob<string>('./blog/*.html', { query: '?raw', import: 'default' });

/** All posts, newest first (ties broken by slug, matching Webflow's listing). */
export const posts: BlogPost[] = Object.values(items).sort(
  (a, b) => b.date.localeCompare(a.date) || a.slug.localeCompare(b.slug),
);

export const getPost = (slug: string) => posts.find((p) => p.slug === slug);

export async function loadPostBody(slug: string): Promise<string> {
  return (await bodies[`./blog/${slug}.html`]?.()) ?? '';
}

/** Posts outside the featured slot, as listed under "Latest articles" and "Recent articles". */
export const latestPosts = posts.filter((p) => !p.featured);
export const featuredPosts = posts.filter((p) => p.featured);
